<template>
  <b-modal
    header-close-content=""
    class="exception-dialog"
    ok-only
    :title="title"
    title-class="text-danger"
    size="xl"
    v-if="errors && errors.length"
    v-model="visible">
    <div class="limited-height exception-dialog">
      <div v-if="cspError">
        <div class="alert alert-warning">
          <p
            v-dompurify-html="
              $t('ContentSecurityPolicyViolatedMessage', {
                resource: cspError.cspState.lastViolation.blockedURI,
                directive: cspError.cspState.lastViolation.effectiveDirective
              })
            "
            class="mb-0"
            style="overflow-wrap: break-word; white-space: pre-wrap"></p>
        </div>
      </div>
      <template v-else>
        <div v-if="hasNetworkError">
          <div class="alert alert-warning">
            <h4 class="alert-heading">{{ $t("NetworkIssues") }}!</h4>
            <p class="mb-0">{{ $t("AppName") }} {{ $t("NetworkErrorMessage") }}</p>
          </div>
        </div>
        <div v-if="singleError">
          <api-exception-message :hide-header="true" :exception="singleError.exception" v-if="singleError.type == 'api'"></api-exception-message>
          <javascript-exception :hide-header="true" :exception="singleError.exception" v-else></javascript-exception>
        </div>
        <ol class="exception-list text-danger" v-else>
          <li v-for="(error, index) in filteredErrors" :key="index">
            <api-exception-message :exception="error.exception" v-if="error.type == 'api'"></api-exception-message>
            <javascript-exception :exception="error.exception" v-else></javascript-exception>
          </li>
        </ol>
      </template>
    </div>
  </b-modal>
</template>

<script>
import ApiExceptionMessage from "./ApiExceptionMessage.vue";
import JavascriptException from "./JavascriptException.vue";

export default {
  components: { ApiExceptionMessage, JavascriptException },
  props: ["errors"],
  data() {
    return { visible: false };
  },
  watch: {
    visible(nv) {
      if (!nv) this.$emit("update:errors", []);
    },
    errors(nv) {
      if (nv && nv.length) this.visible = true;
    }
  },
  computed: {
    singleError() {
      if (this.filteredErrors.length == 1) return this.filteredErrors[0];
      return null;
    },
    filteredErrors() {
      if (!this.hasNetworkError) return this.errors;
      return this.errors.filter((x) => x.type != "network" && x.type != "api");
    },
    hasApiErrors() {
      return this.errors.some((x) => x.type == "api");
    },
    title() {
      if (this.cspError) return this.$t("CSPViolation");
      else if (this.singleError) return this.singleError.exception?.message ?? this.singleError.message ?? "";
      else if (this.hasNetworkError) return this.$t("CheckNetwork");
      else return this.$t("UnexpectedException");
    },
    hasNetworkError() {
      return this.errors.some((x) => x.type == "network");
    },
    cspError() {
      return this.errors.find((x) => x.type == "csp");
    }
  }
};
</script>
